'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var advancedFont = require('../plugins/advancedFont.js');
var borderGradient = require('../plugins/borderGradient.js');
var focusRing = require('../plugins/focusRing.js');
var gradientMask = require('../plugins/gradientMask.js');
var hideScrollbar = require('../plugins/hideScrollbar.js');
var typography = require('../plugins/typography.js');
var typographyCode = require('../plugins/typography-code.js');

/**
 * Export as Tailwind Preset.
 */ const preset = {
    content: [],
    plugins: [
        borderGradient.default,
        focusRing.default,
        hideScrollbar.default,
        gradientMask.default,
        advancedFont.default,
        typography.default,
        typographyCode.default
    ]
};

exports.default = preset;
//# sourceMappingURL=plugins.js.map
